import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 260 190"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "130",
      height: "130",
      x: "61",
      y: "37",
      fill: "#515358",
      rx: "24"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#bebfc0",
      d: "M111.071 106.908a15.7 15.7 0 0 1-.793-4.908c0-5.197 2.533-9.79 6.419-12.652l-6.829-12.636C101.532 82.04 96 91.372 96 102c0 4.095.823 7.996 2.309 11.553zM126 117.721a15.7 15.7 0 0 0 5.488-1.004l6.829 12.636A29.9 29.9 0 0 1 126 132c-9.515 0-17.988-4.434-23.484-11.342l11.983-7.964c2.87 3.085 6.954 5.027 11.501 5.027m0-31.442a15.7 15.7 0 0 0-5.489 1.004l-6.828-12.636A29.9 29.9 0 0 1 125.999 72c10.561 0 19.84 5.462 25.186 13.71l-12.7 6.765c-2.871-3.76-7.388-6.196-12.485-6.196M141.721 102c0-2.256-.484-4.397-1.34-6.337l12.056-7.85A29.86 29.86 0 0 1 156 102c0 10.629-5.533 19.96-13.869 25.288l-6.828-12.635c3.886-2.861 6.418-7.455 6.418-12.652m-13.268-1.292a2.527 2.527 0 0 0-3.408-1.075l-9.666 5.033a11 11 0 0 1-.34-2.667c0-6.054 4.907-10.962 10.961-10.962s10.961 4.908 10.961 10.962-4.907 10.962-10.961 10.962a10.9 10.9 0 0 1-7.465-2.951l9.075-6.031a2.54 2.54 0 0 0 .843-3.271"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "placeholder"}) } }